import { client } from "../lib";

export const getFaqs = async () => {
    return await client.fetch('*[_type == "faq"]');
};